// =====================================================
// SCHEMAS: ASSOCIATION
// Description: Schémas de validation Zod pour les associations
// =====================================================

import { z } from 'zod';

export const createAssociationSchema = z.object({
  name: z.string().min(1, 'Le nom est requis').max(200, 'Le nom est trop long'),
});

export const updateAssociationSchema = z.object({
  name: z.string().min(1, 'Le nom est requis').max(200, 'Le nom est trop long'),
});

export type CreateAssociationInput = z.infer<typeof createAssociationSchema>;
export type UpdateAssociationInput = z.infer<typeof updateAssociationSchema>;
